'use client';

import { usePathname } from 'next/navigation';
import { langFromPathname, type Lang } from './config';

/** Active locale, derived from the URL, for client components. */
export function useLang(): Lang {
  return langFromPathname(usePathname() ?? '/');
}
